import React, { useEffect, useState } from 'react'
import { Button, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap'
import Header from '../../header/Header'
import Footer from '../../footer/Footer'
import { MultiSelect } from 'react-multi-select-component'
import backendAPI from '../../../services/backend'
import AlertModal from '../../Modals/alertModal/AlertModal'
import WaitingModal from '../../Modals/waitingModal/WaitingModal'
import ConfirmationModal from '../../Modals/confirmationModal/ConfirmationModal'
import './Restrictions.css'

const Restrictions = (props) => {
    const [isWaitingModalOpen, setIsWaitingModalOpen] = useState(true)
    const [message, setMessage] = useState()
    const [error, setError] = useState()
    const [alertHeader, setAlertHeader] = useState('Error')
    
    const [divisionsList, setDivisionsList] = useState([])
    const [queuesList, setQueuesList] = useState([])
    
    const [divisionsSelected, setDivisionsSelected] = useState([])
    const [queuesSelected, setQueuesSelected] = useState([])

    const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(!!message);

    // -------- LOAD LISTS + CURRENT RESTRICTIONS ON LOAD ---------
    useEffect(() => {
        const loadData = async () => {
            try {
                const token = sessionStorage.getItem('r2s-token')

                // Allowed values
                const meResp = await backendAPI.getUsersMe(token)
                setDivisionsList(
                    meResp.user.divisions
                        ? meResp.user.divisions.filter((d) => d.value !== '*')
                        : []
                )
                setQueuesList(
                    meResp.user.queues
                        ? meResp.user.queues.filter((q) => q.value !== '*')
                        : []
                )

                // Current restrictions
                let restrictionsResp = await backendAPI.getRestrictions(token);
                restrictionsResp = restrictionsResp.results;

                setDivisionsSelected(meResp.user.divisions.filter((d) => restrictionsResp.divisions.includes(d.value)));
                setQueuesSelected(meResp.user.queues.filter((q) => restrictionsResp.queues.includes(q.value)));
            } catch (err) {
                console.error(err)
                setAlertHeader('Error')
                setError(`An error occurred while fetching data: ${err.message || err}`)
            } finally {
                setIsWaitingModalOpen(false)
            }
        }

        loadData()
    }, [])

    // ---------------- SUBMIT ----------------
    const handleSubmit = async () => {

        const payload = {
            divisions: divisionsSelected,
            queues: queuesSelected,
        }

        try {
            setIsWaitingModalOpen(true)
            const token = sessionStorage.getItem('r2s-token')

            await backendAPI.updateRestrictions(token, payload)

            setIsConfirmationModalOpen(true);
            setMessage('Restrictions have been updated successfully')
        } catch (err) {
            console.error(err)
            setAlertHeader('Error')
            setError(`An error occurred while updating data: ${err.message || err}`)
        } finally {
            setIsWaitingModalOpen(false)
        }
    }

    const handleCancel = () => {
        if (props.cancel) {
            props.cancel()
        } else {
            window.history.back()
        }
    }

    const handleConfirmationOk = () => {
        setIsConfirmationModalOpen(false);
    };

    return (
        <div id="component-wrap">
            <Header role={props.role} />
            <label className="restriction-title">Update Restrictions</label>
            <hr className="hori-line" />

            <div id="main">
                <WaitingModal
                    isOpen={isWaitingModalOpen}
                    header="Loading Restrictions"
                />

                <ConfirmationModal
                    isOpen={isConfirmationModalOpen}
                    header="Success!"
                    toggle={() => {
                        setMessage(undefined)
                    }}
                    body={message}
                    button1={handleConfirmationOk}
                />

                <AlertModal
                    isOpen={!!error}
                    header={alertHeader}
                    toggle={() => {
                        setError(undefined)
                    }}
                    body={error}
                />

                <br />
                <div className="form-elements">
                    {/* Divisions */}
                    <InputGroup className="text-box">
                        <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                                Divisions
                            </InputGroupText>
                        </InputGroupAddon>

                        <MultiSelect
                            className="multi-drop-down"
                            options={divisionsList}
                            value={divisionsSelected}
                            onChange={setDivisionsSelected }
                            labelledBy="Select"
                        />
                    </InputGroup>

                    <br />

                    {/* Queues */}
                    <InputGroup className="text-box">
                        <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                                queues
                            </InputGroupText>
                        </InputGroupAddon>

                        <MultiSelect
                            className="multi-drop-down"
                            options={queuesList}
                            value={queuesSelected}
                            onChange={setQueuesSelected}
                            labelledBy="Select"
                        />
                    </InputGroup>

                    <br />

                    {/* BUTTONS – Save left, Cancel right */}
                    <div className="button-row">
                        <Button
                            color="primary"
                            onClick={handleSubmit}
                            disabled={props.loading}
                        >
                            {props.okButtonText ? props.okButtonText : 'Save'}
                        </Button>

                        <Button
                            color="secondary"
                            disabled={props.loading}
                            onClick={handleCancel}
                        >
                            {props.cancelButtonText ? props.cancelButtonText : 'Cancel'}
                        </Button>
                    </div>

                    <br />
                </div>
            </div>

            <Footer version="0.1" />
        </div>
    )
}

export default Restrictions
